export default "/img/US.bdcaa97577de340aec56612ac590c40a.png";